export default __webpack_public_path__ + "static/media/sports08.3c5a5bdb.jpg";